export default {
  1: 'admin',
  2: 'operator',
  3: 'dentist'
}
